<template>
  <div
    class="items-center justify-center w-full p-4 bg-card rounded-[var(--radius)] border border-border flex items-start gap-3"
  >
    <div class="relative h-10 flex items-center justify-center shrink-0">
      <svg-icon
        :name="getFileTypeIcon()"
        class="w-6 h-6 text-muted-foreground"
      />
    </div>

    <div class="flex-1 min-w-0 flex flex-col">
      <p
        class="text-foreground font-medium leading-5 line-clamp-1"
        :title="file.file_name"
        style="font-size: 12.5px"
      >
        {{ file.name || file.file_name }}
      </p>

      <p class="text-muted-foreground text-sm leading-5">
        {{ formatFileSize(file.size || file.file_size) }}
      </p>
    </div>

    <div class="flex items-center justify-center gap-2.5">
      <Button
        v-if="actions.includes('remove')"
        variant="outline"
        class="text-foreground w-9 h-9"
        size="icon"
        @click="$emit('remove', file)"
      >
        <svg-icon name="huge-danger" class="w-4 h-4 icon-style" />
      </Button>

      <Button
        v-if="actions.includes('download')"
        variant="outline"
        size="icon"
        class="text-foreground w-9 h-9"
        @click="$emit('download', file)"
      >
        <svg-icon name="huge-download" class="w-4 h-4 icon-style" />
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/shared/ui/button/Button.vue";

export default {
  name: "AttachmentItem",
  components: { Button },
  props: {
    file: {
      type: Object,
      required: true,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatFileSize(size) {
      if (!size) return "0 B";

      const units = ["B", "KB", "MB", "GB"];
      let i = 0;

      while (size >= 1024 && i < units.length - 1) {
        size /= 1024;
        i++;
      }

      return `${size.toFixed(2)} ${units[i]}`;
    },

    getFileTypeIcon() {
      const type = this.file?.content_type || "";

      if (type.includes("pdf")) return "huge-pdf";
      else if (type.includes("xls")) return "huge-xls";
      else if (type.includes("txt")) return "huge-txt";
      else if (type.includes("doc")) return "huge-doc";
      else if (type.includes("docx")) return "huge-docx";
      else if (type.includes("xlsx")) return "huge-xlsx";
      else if (type.includes("bmp")) return "huge-bmp";
      else if (type.includes("png")) return "huge-png";
      else if (type.includes("jpg")) return "huge-jpg";
      else if (type.includes("jpeg")) return "huge-jpeg";

      return "huge-document-list";
    },
  },
};
</script>

<style lang="scss" scoped></style>
